export default "__VITE_ASSET__apWcV$6u__"